import styled from 'styled-components';
import {FlexCentered} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const Container = styled.div(
  props => `
  background:${props.theme.colors.goYellow.light};
  border: ${props.theme.misc.border.base} solid ${props.theme.colors.goYellow.medium};
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  margin: 0 0 ${props.theme.spacing.custom(8)} 0;
  cursor: pointer;
  width: ${props.width || '100%'};
`,
);

export const IconWrap = styled.div(
  props => `
  display: flex;
  flex-wrap:wrap;
  flex-direction: column;
  padding:${props.theme.spacing.custom(7)};
  margin: 0 ${props.theme.spacing.small} 0 0
  width:3.2rem;
  height:3.2rem;
  border-radius:50%;
  background-color:${props.theme.colors.goBrandBlue.base};
`,
);

export const SignUpDealPrice = styled(FlexCentered)(
  props => `
  margin-bottom: ${props.theme.spacing.small};
`,
);

export const SignUpContentWrap = styled.div(
  props => `
  padding: ${props.theme.spacing.base};
`,
);

export const SignUpHeaderWrap = styled.p(
  props => `

  font-size:${props.theme.font.custom(11)};
  color:${props.theme.colors.goWhite.base};
  padding:${props.theme.spacing.base};
  font-family:${props.theme.font.fontFamily};
  font-weight:bold;
  background-image: linear-gradient(276deg, #f8cd46, #f4a900);
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  border-bottom-left-radius:0;
  border-bottom-right-radius:0;
  display:flex;

`,
);

export const SignUpMemberPrice = styled.p(
  props => `

  font-size:${props.theme.font.custom(16)};
  font-family: ${props.theme.font.fontFamily};
  font-weight:bold;
  color:${props.theme.colors.goZest.dark};
  margin-bottom: ${props.theme.spacing.base};

`,
);

export const SignUpDealPriceText = styled.p(
  props => `

  font-size:${props.dealPriceTextSize || props.theme.font.custom(16)};
  font-weight:bold;
  margin-right: ${props.theme.spacing.small};
`,
);

export const SignUpDealPerNight = styled.p(
  props => `
  font-size: ${props.perRoomPerNightTextSize};
  color:${props.theme.colors.downriver.medium};
  text-transform: ${props.perRoomPerNightLabelTextTransform || 'lowercase'}
`,
);

export const SignUpStaticText = styled.p(
  props => `
  display: inline-flex;
  color:${props.theme.colors.downriver.dark};
`,
);

export const offerIconProps = {
  width: '1.8rem',
  height: '1.8rem',
  fill: 'white',
};

export const DealsPersuasionText = styled.p(
  props => `
  display: inline-flex;
  color:${props.theme.colors.goBrandBlue.base};
  font-weight:bold;
  font-size:${props.theme.font.custom(16)};
`,
);

// export const SignUpPersuasionText = () => (
//   <SignUpTextContainer>
//     <SignUpStaticText>Sign Up & Get</SignUpStaticText>
//     <DealsPersuasionText>The Best Deals & Prices</DealsPersuasionText>
//   </SignUpTextContainer>
// );

// function SignUpPersiasion({ onClick }) {
//   return (
//     <Container onClick={onClick}>
//       <IconWrap>
//         <OfferIcon {...offerIconProps} />
//       </IconWrap>
//       <SignUpPersuasionText />
//     </Container>
//   );
// }
